<div class="intervention-content">
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <div class="intervention-content__title">{{ selectedIntervention?.name }}</div>
    <mat-icon
      matTooltipClass="dashboard-mat-tooltip"
      [matTooltip]="INTERVENTION_CONTENT_TOOLTIP"
      matTooltipPosition="left"
      >help</mat-icon
    >
  </div>
  <div fxLayout="column">
    <div cdkDropList [cdkDropListData]="interventionModulesAndInformativePages" (cdkDropListDropped)="dropItem($event)">
      <div
        class="intervention-content__list"
        *ngFor="let item of interventionModulesAndInformativePages"
        cdkDragLockAxis="y"
        cdkDrag
      >
        <div fxLayout="row" fxLayoutAlign="space-between center">
          <div
            (dblclick)="onOpenModulesTab(item)"
            class="intervention-content__list-item"
            fxLayout="column"
            fxLayoutAlign="space-around start"
            fxFlex="80"
          >
            <label class="intervention-content__list-item-title">
              {{
                item?.translations
                  ? (item?.translations | dashboardTranslate: 'title':selectedLanguage?.code)
                    ? (item?.translations | dashboardTranslate: 'title':selectedLanguage?.code)
                    : 'Untitled page'
                  : item.name
              }}
            </label>
            <label class="intervention-content__list-item-info">{{ item?.name ? item.name : '' }}</label>
          </div>
          <mat-icon
            *ngIf="
              item.type === ItemType.MODULE &&
              privilegeService.hasPrivilege(PRIVILEGE_SECTIONS.INTERVENTIONS, PRIVILEGE_ACTIONS.ALL)
            "
            class="intervention-content__list-item-caption"
            [color]="item.isCompassStart ? 'primary' : 'accent'"
            #tooltip="matTooltip"
            [matTooltip]="
              item.isCompassStart
                ? 'This module is the start of The Career Compass'
                : 'Set this module as a start of The Career Compass'
            "
            matTooltipPosition="above"
            (click)="setStartModule(item)"
          >
            closed_caption
          </mat-icon>
          <mat-icon
            *ngIf="privilegeService.hasPrivilege(PRIVILEGE_SECTIONS.INTERVENTIONS, PRIVILEGE_ACTIONS.ALL)"
            class="intervention-content__list-item-delete"
            color="primary"
            #tooltip="matTooltip"
            matTooltip="Delete item from this intervention"
            matTooltipPosition="above"
            (click)="onDelete(item)"
          >
            delete
          </mat-icon>
        </div>
      </div>
    </div>
    <form [formGroup]="interventionContentForm">
      <div class="intervention-content__content" fxLayout="column" fxLayoutAlign="space-between stretch">
        <div
          *ngIf="
            interventionModulesSelectList?.length &&
            privilegeService.hasPrivilege(PRIVILEGE_SECTIONS.INTERVENTIONS, PRIVILEGE_ACTIONS.ALL)
          "
        >
          <mat-form-field appearance="fill" fxFlex="70">
            <mat-select formControlName="moduleId" placeholder="- Select a module -">
              <mat-option *ngFor="let module of interventionModulesSelectList" [value]="module.id">
                {{ module?.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div fxFlex="30" fxLayoutAlign="end center">
            <button
              (click)="onAddContentItem(SELECT_LIST_ITEM_TYPE.MODULE)"
              mat-button
              color="primary"
              type="button"
              class="intervention-content__content-small-button"
            >
              <span class="material-icons">add</span>
              {{ 'Add' | uppercase }}
            </button>
          </div>
        </div>
        <div *ngIf="interventionInformativePageSelectList?.length">
          <mat-form-field appearance="fill" fxFlex="70">
            <mat-select formControlName="informativePageId" placeholder="- Select an informative page-">
              <mat-option *ngFor="let page of interventionInformativePageSelectList" [value]="page.id">
                {{
                  (page?.translations | dashboardTranslate: 'title':selectedLanguage?.code)
                    ? (page?.translations | dashboardTranslate: 'title':selectedLanguage?.code)
                    : 'Untitled page'
                }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div fxFlex="30" fxLayoutAlign="end center">
            <button
              (click)="onAddContentItem(SELECT_LIST_ITEM_TYPE.INFORMATIVE_PAGE)"
              mat-button
              color="primary"
              type="button"
              class="intervention-content__content-small-button"
            >
              <mat-icon>add</mat-icon>
              {{ 'Add' | uppercase }}
            </button>
          </div>
        </div>
      </div>
    </form>
    <div
      *ngIf="
        privilegeService.hasPrivilege(PRIVILEGE_SECTIONS.INTERVENTIONS, PRIVILEGE_ACTIONS.ALL) &&
        (privilegeService.hasPrivilege(PRIVILEGE_SECTIONS.MODULES, PRIVILEGE_ACTIONS.ALL) ||
          privilegeService.hasPrivilege(PRIVILEGE_SECTIONS.MODULES, PRIVILEGE_ACTIONS.VIEW))
      "
      class="intervention-content__content"
      fxLayout="column"
      fxLayoutAlign="space-around center"
    >
      <p *ngIf="!modules?.length && !informativePages?.length" class="intervention-content__content-text">
        There are no informative pages and modules in this study
      </p>
      <p *ngIf="!interventionModulesSelectList?.length && modules?.length" class="intervention-content__content-text">
        You've added all available modules
      </p>
      <p
        *ngIf="!interventionInformativePageSelectList?.length && informativePages?.length"
        class="intervention-content__content-text"
      >
        You've added all available informative pages
      </p>
    </div>
  </div>
</div>
